module.exports = __webpack_public_path__ + "images/ferrari_small852b226c97d79b307b072027d4fcb4b1.png";